export default __webpack_public_path__ + "static/media/modal_close_ic.46ba62fe.svg";